const types = {
	SET_SEARCH_TEXT_START: "SET_SEARCH_TEXT_START",
	SET_SEARCH_TEXT_SUCCESS: "SET_SEARCH_TEXT_SUCCESS",
	SET_SEARCH_TEXT_ERROR: "SET_SEARCH_TEXT_ERROR",
	SET_SEARCH_TEXT_RESET: "SET_SEARCH_TEXT_RESET",
	//create update
};

export default types;
